const functionsSchema = [
  {
    name: 'hideAddProductOrGroup',
    initialValue: '',
    input: {
      placeholder: 'Add Product/Group',
      className: 'hideAddProductOrGroup',
      label: 'Add Product/Group',
      type: 'checkbox',
    },
  },
  {
    name: 'hideAddCustomer',
    initialValue: '',
    input: {
      placeholder: 'Add New Customer',
      className: 'hideAddCustomer',
      label: 'Add New Customer',
      type: 'checkbox',
    },
  },
  {
    name: 'hideRecentSales',
    initialValue: '',
    input: {
      placeholder: 'Recent Sales',
      className: 'hideRecentSales',
      label: 'Recent Sales',
      type: 'checkbox',
    },
  },
  {
    name: 'hidePendingSales',
    initialValue: '',
    input: {
      placeholder: 'Pending Sales',
      className: 'hidePendingSales',
      label: 'Pending Sales',
      type: 'checkbox',
    },
  },
  {
    name: 'hideOrders',
    initialValue: '',
    input: {
      placeholder: 'Pickup Orders',
      className: 'hideOrders',
      label: 'Pickup Orders',
      type: 'checkbox',
    },
  },
  {
    name: 'hideLayaways',
    initialValue: '',
    input: {
      placeholder: 'Layaways',
      className: 'hideLayaways',
      label: 'Layaways',
      type: 'checkbox',
    },
  },
  {
    name: 'hideCloseDay',
    initialValue: '',
    input: {
      placeholder: 'Close Day',
      className: 'hideCloseDay',
      label: 'Close Day',
      type: 'checkbox',
    },
  },
  {
    name: 'hideXReport',
    initialValue: '',
    input: {
      placeholder: 'X-Report',
      className: 'hideXReport',
      label: 'X-Report',
      type: 'checkbox',
    },
  },
  {
    name: 'hideCashInOut',
    initialValue: '',
    input: {
      placeholder: 'Cash In/Out',
      className: 'hideCashInOut',
      label: 'Cash In/Out',
      type: 'checkbox',
    },
  },
  {
    name: 'hidePriceLookup',
    initialValue: '',
    input: {
      placeholder: 'Price Lookup',
      className: 'hidePriceLookup',
      label: 'Price Lookup',
      type: 'checkbox',
    },
  },
  {
    name: 'hideClockInOut',
    initialValue: '',
    input: {
      placeholder: 'Clock In/Out',
      className: 'hideClockInOut',
      label: 'Clock In/Out',
      type: 'checkbox',
    },
  },
  {
    name: 'hideGiftCardBalance',
    initialValue: '',
    input: {
      placeholder: 'Check Gift Card Balance',
      className: 'hideGiftCardBalance',
      label: 'Check Gift Card Balance',
      type: 'checkbox',
    },
  },
  {
    name: 'hidePrintCoupons',
    initialValue: '',
    input: {
      placeholder: 'Print Coupons',
      className: 'hidePrintCoupons',
      label: 'Print Coupons',
      type: 'checkbox',
    },
  },
  {
    name: 'hideSwitchUser',
    initialValue: '',
    input: {
      placeholder: 'Switch User Button',
      className: 'hideSwitchUser',
      label: 'Switch User Button',
      type: 'checkbox',
    },
  },
  {
    name: 'isCustomerHomeStoreDisabled',
    initialValue: '',
    input: {
      placeholder: 'Show Home Store',
      className: 'isCustomerHomeStoreDisabled',
      label: 'Show Home Store',
      type: 'checkbox',
    },
  },
];

export default functionsSchema;
